<template>
  <div style="height: 100%; width: 100%">
    <a-row style="height: 300px" class="bg">
      <a-col :span="12">
        <div>
          <div style="display: flex; " class="biaoti">

            <h1 style="color: #fff; font-size: 14px; ">
              本月电费节省图(单位:元)
            </h1>
          </div>
          <div style="height: 240px">
            <DianFei />
          </div>
        </div>
      </a-col>

      <a-col :span="12">
        <div>
          <div style="display: flex;" class="biaoti">

            <h1 style="color: #fff; font-size: 14px; ">
              本月充放电量图
            </h1>
          </div>
          <div style="height: 240px">
            <v-chart class="chart" :option="options" :autoresize="true" />
          </div>
        </div>
      </a-col>
    </a-row>

    <div class="cfdian" style="margin-top: 20px; height: calc(100% - 403px);padding-top: 5px;">
      <div style="display: flex; " class="biaoti">

        <h1 style="color: #fff; font-size: 14px;">统计指标</h1>
      </div>
      <TongJi />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from "vue";
import * as echarts from 'echarts';

import TongJi from "./TongJi.vue";
import DianFei from "./DianFei.vue";

export default defineComponent({
  components: {

    TongJi,
    DianFei,
  },
  props: { info: Object },
  setup(props) {
    const options = ref({
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '2%',
        top: '6%',
        containLabel: true
      },
      // legend: {
      //     data: ['充电', '放电'],
      //     right: '7%',
      //     top:'-5%',
      //     textStyle: {
      //         color: "#666666"
      //     },
      //     itemWidth: 15,
      //     itemHeight: 10,
      //     itemGap: 25
      // },
      xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
          color: '#A0A4AA'
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(65, 97, 128, 0.5)',
          },
        },
        axisTick: {
          alignWithLabel: true
        }
      },
      yAxis: [{
        type: 'value',
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(163, 163, 163, 0.5)',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: '#A0A4AA'
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(65, 97, 128, 0.5)',
          },
        },
      },
      {
        type: "value",
        name: "",
        nameTextStyle: {
          color: "#666666"
        },
        position: "right",
        axisLine: {
          lineStyle: {
            color: '#cdd5e2'
          }
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
          formatter: "{value} %", //右侧Y轴文字显示
          textStyle: {
            color: "#666666"
          }
        }
      }
      ],
      series: [{
        name: '充电',
        type: 'bar',
        barWidth: '12px',
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#12BDDF'
            }, {
              offset: 1,
              color: 'rgba(24, 253, 255, 0.5)'
            }]),
          },
        },
        data: []
      },
      {
        name: '放电',
        type: 'bar',
        barWidth: '12px',
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#DE9600'
            }, {
              offset: 1,
              color: 'rgba(255, 183, 24,0.5)'
            }]),
          }
        },
        data: []
      }
      ]
    });

    watch(props, () => {

      props.info.charge_discharge.some((item) => {
        options.value.xAxis.data.push(item.currentMonth)
        options.value.series[0].data.push(item.chargeTotal)
        options.value.series[1].data.push(item.dischargeTotal)

      })
    }, {
      deep: true
    });

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
    });

    return {
      options,
    };
  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  background: url("@/assets/bjk3.png");
  background-size: 100% 100%;
}

.cfdian {
  background: url("@/assets/bjk5.png");
  background-size: 100% 100%;
}

.biaoti {
  background: url("@/assets/biaoti.png") no-repeat;
  margin-left: 40px;
  margin-top: 12px;
  font-weight: bold;
  padding-left: 30px;
}

.topbg {
  background: url("@/assets/u64.png") no-repeat bottom center;
}

.hgao {
  /* height: calc(100% - 53px); */
  width: 100%;
}

.shuliang {
  color: #38f2fe;
  font-size: 40px;
  font-family: Arial, Helvetica, sans-serif;
}

.hoptions {
  height: calc(100% - 53px);
}

.ant-col-8 {
  max-width: 100%;
}

.ant-col-6 {
  max-width: 100%;
}
</style>
